import React from "react";
import GenericDialog from "@components/GenericDialog/GenericDialog";
import type { SequenceView } from "@services/drybulkCargoOperationsApi";
import { useTranslation } from "react-i18next";
import { DRYBULK_CARGO_OPS_LANG_BASE } from "../constants";

const L = `${DRYBULK_CARGO_OPS_LANG_BASE}.sequences.remove`;

/** DBCO-0029 (R-48) - asks before the DELETE; nothing is removed until the user confirms. */
const RemoveSequenceDialog: React.FC<{
  sequence: SequenceView | null;
  isSubmitting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}> = ({ sequence, isSubmitting, onConfirm, onCancel }) => {
  const { t } = useTranslation();
  return (
    <GenericDialog
      open={sequence !== null}
      testId="remove-sequence-dialog"
      title={t(`${L}.title`)}
      content={t(`${L}.message`, { sequenceNo: sequence?.sequenceNo })}
      cancelButtonText={t(`${L}.cancel`)}
      confirmButtonText={t(`${L}.confirm`)}
      handleCloseDialog={onCancel}
      confirmAction={onConfirm}
      isSubmitting={isSubmitting}
    />
  );
};

export default RemoveSequenceDialog;
